import React, { useState, useEffect } from "react";
import "./Auditorium.scss";
import SectionTitle2 from "../../components/SectionTitle/SectionTitle2";


import img from "../../assets/Infrastructure/Auditorium/img.jpeg";


const images = [img, ];

const Auditorium = () => {

  const [current, setCurrent] = useState(0);
  
    useEffect(() => {
      const timer = setInterval(() => {
        setCurrent((prev) => (prev + 1) % images.length);
      }, 3500);
      return () => clearInterval(timer);
    }, []);
  
  return (
   <>
   {/* <SectionTitle2 title="ABOUT AUDITORIUM" /> */}
    <section className="auditorium">
      <div className="container">
        <h1 className="page-title">ABOUT AUDITORIUM</h1>

{/* IMAGE CAROUSEL */}
        <div className="classroom-carousel">
          {images.map((img, index) => (
            <div
              key={index}
              className={`slide ${index === current ? "active" : ""}`}
            >
              <img src={img} alt={`Class Room ${index + 1}`} />
            </div>
          ))}
        </div>


        <div className="content-card">
          <p className="intro">
            Our state-of-the-art auditorium is a hub for academic and cultural events which, hosting lectures, seminars, conferences, and performances that foster intellectual discourse and creativity with a seating capacity of 500. With modern facilities and equipment, it provides an ideal setting for students, faculty and guests to engage with ideas and showcase their talents.
          </p>

          {/* <p>
            Designed to host <strong>lectures, seminars, conferences, workshops,
            and performances</strong>, the auditorium fosters intellectual
            discourse, creativity, and collaboration among students, faculty,
            and guests.  Seating Capacity: 500
          </p> */}

          {/* <div className="highlight">
            Seating Capacity: <strong>500</strong>
          </div> */}

          {/* <p>
            Equipped with <strong>modern audio-visual facilities</strong> and
            advanced infrastructure, the auditorium provides an ideal setting
            for knowledge-sharing, talent showcase, and academic excellence.
          </p> */}
        </div>
      </div>
    </section>
   </>
  );
};

export default Auditorium;
